import * as React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useContext, useState, useEffect } from "react";
import Logo from "../../assets/logo/1800AccountantLogo.svg";
import { AppContext } from "../routing/Routing";
import { VIEWS } from "../constants/user-info.const";
import { Button, Link } from "@mui/material";
import {
    appendTokenToHeader,
    clearAuthData,
    logoutService,
} from "../../services/authService";
import { useNavigate } from "react-router-dom";
import store from "../../store";
import { showAlert } from "../../store/actions/feedback";
import Loader from "./Loader";
import SendDetailsToEmployer from "./ui/SendDetailsToEmployer";
import { connect } from "react-redux";
import { removeUserType } from "../../utils/login";
import { useAppState } from "../../provider/AppProvider";

function ADPAppHeader(props) {
    const { viewName } = useContext(AppContext);
    const smDevice = useMediaQuery("(max-width:600px)");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [isDisableSendToEmployer, setIsDisableSendToEmployer] =
        useState(true);
    const { isEnableSendToEmployer } = props;
    const { logo } = useAppState()

    useEffect(() => {
        if (isEnableSendToEmployer) {
            setIsDisableSendToEmployer(false);
            return;
        }
        setIsDisableSendToEmployer(true);
    }, [isEnableSendToEmployer]);

    const showErrorMessage = (error) => {
        const errorMessage = error.status?.message;
        store.dispatch(
            showAlert({
                alertType: "error",
                alertText: errorMessage,
            })
        );
    };
    const signOutUser = () => {
        setIsLoading(true);
        logoutService()
            .then(() => {
                setIsLoading(false);
                navigate("/");
                appendTokenToHeader();
                clearAuthData();
                removeUserType();
            })
            .catch((error) => {
                setIsLoading(false);
                showErrorMessage(error);
            });
    };
    const sendToEmployer = () => {
        setShowConfirmModal(true);
    };
    const onModalClose = () => {
        setShowConfirmModal(false);
    };
    const appHeader = () => {
        return (
            <>
                {showConfirmModal && (
                    <SendDetailsToEmployer onClose={onModalClose} />
                )}
                {isLoading ? (
                    <Loader />
                ) : (
                    <div className="adp-header">
                        <div className="container">
                            <div>
                                <img src={logo} alt="1800-Accountant logo" />
                            </div>
                            <div className="sign-out">
                                <Link
                                    href="#"
                                    className="primary-link"
                                    onClick={signOutUser}
                                >
                                    Sign Out
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };
    const showHideAppHeader = () => {
        if (!smDevice) {
            return appHeader();
        }
        if (!viewName || viewName === VIEWS.toolbar) {
            return appHeader();
        }
    };
    return <>{showHideAppHeader()}</>;
}

const mapStateToProps = (state) => ({
    isEnableSendToEmployer: state.eSign.isEnableSendToEmployer,
});
export default connect(mapStateToProps)(ADPAppHeader);
